import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page46',
  templateUrl: './page46.component.html',
  styleUrls: ['./page46.component.css']
})
export class Page46Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
